import { useEffect, useState } from "react";
import { api, gbp } from "@/lib/api";
import RetailerLayout from "@/components/RetailerLayout";

export default function RetailerReservations() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/retailer/reservations")
      .then((r) => setItems(r.data.reservations || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <RetailerLayout>
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-6" data-testid="reservations-page">
        <h1 className="font-display font-bold text-2xl text-slate-900 mb-4">Reservations</h1>
        {loading ? (
          <div className="text-slate-500">Loading…</div>
        ) : items.length === 0 ? (
          <div className="bg-white border border-slate-200 rounded-xl p-8 text-center text-slate-600">
            No reservations yet. When someone reserves one of your remnants, it'll appear here.
          </div>
        ) : (
          <div className="bg-white border border-slate-200 rounded-xl overflow-x-auto">
            <table className="w-full text-sm min-w-[640px]">
              <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider">
                <tr>
                  <th className="text-left p-3">Reference</th>
                  <th className="text-left p-3">Customer</th>
                  <th className="text-left p-3">Room</th>
                  <th className="text-left p-3">Collection by</th>
                  <th className="text-left p-3">Fitting</th>
                  <th className="text-right p-3">Price</th>
                </tr>
              </thead>
              <tbody>
                {items.map((r) => (
                  <tr key={r.id} className="border-t border-slate-200" data-testid={`res-row-${r.id}`}>
                    <td className="p-3 font-mono text-xs">{r.listing_reference}</td>
                    <td className="p-3">
                      <div className="font-semibold text-slate-900">{r.customer_name}</div>
                      <div className="text-xs text-slate-500">{r.customer_email}</div>
                      <div className="text-xs text-slate-500">{r.customer_phone}</div>
                    </td>
                    <td className="p-3">{r.room_width_m}m × {r.room_length_m}m</td>
                    <td className="p-3">
                      {new Date(r.collection_window_ends_at).toLocaleString("en-GB", {
                        day: "numeric",
                        month: "short",
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </td>
                    <td className="p-3">{r.fitting_interest ? "Yes" : "—"}</td>
                    <td className="p-3 text-right font-semibold">{gbp(r.price_gbp)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </main>
    </RetailerLayout>
  );
}
